import { Entity } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { BrandsAndProducts } from '@terminal/modules/overview-knowledge-graph/components/brands-and-products/BrandsAndProducts';
import { CompetitorsKnowledgeGraph } from '@terminal/modules/overview-knowledge-graph/components/competitors-knowledge-graph/CompetitorsKnowledgeGraph';
import { GeographicExposureKnowledgeGraph } from '@terminal/modules/overview-knowledge-graph/components/geographic-exposure-knowledge-graph/GeographicExposureKnowledgeGraph';
import { LegacyThemeKnowledgeGraph } from '@terminal/modules/overview-knowledge-graph/components/theme-knowledge-graph/LegacyThemeKnowledgeGraph';
import React from 'react';

import { RankingMethodologySection } from '../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import styles from './OverviewTab.module.scss';

export interface OverviewTabProps {
  entity: Entity;
  hasThemeData?: boolean;
  hasBrandsAndProductsData?: boolean;
  hasCompetitorsData?: boolean;
  hasGeographicData?: boolean;
}

export const OverviewTab = ({
  entity,
  hasThemeData = true,
  hasBrandsAndProductsData = false,
  hasCompetitorsData = true,
  hasGeographicData = true,
}: OverviewTabProps) => {
  return (
    <div>
      <div className={styles.gridContainer}>
        {hasThemeData && (
          <ErrorBoundaryWrapper>
            <div className={styles.styledThemeKnowledgeGraph}>
              <LegacyThemeKnowledgeGraph
                entityTag={entity.tag}
                isInDrawer={false}
              />
            </div>
          </ErrorBoundaryWrapper>
        )}
        {hasBrandsAndProductsData && (
          <ErrorBoundaryWrapper>
            <div className={styles.styledBrandsAndProducts}>
              <BrandsAndProducts entity={entity} />
            </div>
          </ErrorBoundaryWrapper>
        )}
        {hasCompetitorsData && (
          <ErrorBoundaryWrapper>
            <div className={styles.styledCompetitorsKnowledgeGraph}>
              <CompetitorsKnowledgeGraph
                entityTag={entity.tag}
                isInDrawer={false}
              />
            </div>
          </ErrorBoundaryWrapper>
        )}
        {hasGeographicData && (
          <ErrorBoundaryWrapper>
            <div className={styles.styledGeographicExposureKnowledgeGraph}>
              <GeographicExposureKnowledgeGraph entity={entity} />
            </div>
          </ErrorBoundaryWrapper>
        )}
      </div>
      <RankingMethodologySection rankingType={'companyToTheme'} />
    </div>
  );
};
